<template>
    <div id='PsSiteSelection' class='col-10 offset-1 col-sm-6 col-md-4 offset-sm-0 offset-md-1 text-center'>
        <Select
            label='Site:'
            store='PowerScan'
            name='currentSite'
            :options='siteOptions'
        />
    </div>
</template>
<script>
    import Select from '../../form/Select'
    export default {
        name: 'PsSiteSelection',
        components:{
            Select
        },
        data(){
            return {
                siteOptions: this.$store.getters['PowerScan/sites'],
                currentSite: this.$store.getters['ProductCollection/currentSite'] == '' ? this.$store.getters['PowerScan/currentSite'] : this.$store.getters['ProductCollection/currentSite']
            }
        },
        /*computed:{
            currentSite:{
                get(){
                    return this.$store.getters['ProductCollection/currentSite'] == '' ? this.$store.getters['PowerScan/currentSite'] : this.$store.getters['ProductCollection/currentSite']
                },
                set(value){
                    return this.$store.dispatch('PowerScan/set', {field: 'currentSite', value}) 
                }
            }
        },*/
        mounted(){
            console.log('PSSiterSelection mounted');
            this.currentSite = this.$store.getters['ProductCollection/currentSite'] == '' ? this.$store.getters['PowerScan/currentSite'] : this.$store.getters['ProductCollection/currentSite']
        },
        watch: {
            currentSite: function (val) {
                console.log('changed location - ', val);
            }
        }
    }
</script>